import { render, staticRenderFns } from "./GroupsUnregisteredCifsDoc.vue?vue&type=template&id=58249928"
import script from "./GroupsUnregisteredCifsDoc.vue?vue&type=script&lang=js"
export * from "./GroupsUnregisteredCifsDoc.vue?vue&type=script&lang=js"
import style0 from "./GroupsUnregisteredCifsDoc.vue?vue&type=style&index=0&id=58249928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports